module.exports = __webpack_public_path__ + "img/mineBg.65bd1d37.png";